export default __webpack_public_path__ + "static/media/education-steps.821444e7.png";